module.exports = __webpack_public_path__ + "img/2_user.4e536f83.svg";